// extracted by mini-css-extract-plugin
export default {"button-wrapper":"styles_button-wrapper__CNn6N","content":"styles_content__NP8yB","buttons":"styles_buttons__X35BR","form-item":"styles_form-item__omI2a"};